import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pas_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-canvas-soft px-6">
      <div className="w-full max-w-sm bg-white p-10 shadow-sm border border-canvas-deep">
        <h1 className="font-heading text-3xl text-ink mb-2">Pasionaria</h1>
        <p className="text-ink-soft text-sm mb-8">Panel de administración</p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-wide text-ink-soft">Correo</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border-b border-brand-secondary bg-transparent py-2 focus:border-brand-primary focus:outline-none text-ink"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide text-ink-soft">Contraseña</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border-b border-brand-secondary bg-transparent py-2 focus:border-brand-primary focus:outline-none text-ink"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-destructive text-sm">{error}</p>}
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-brand-primary text-white py-3 text-sm uppercase tracking-wide hover:bg-brand-dark transition-colors disabled:opacity-50"
          >
            {loading ? "..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}
